import $ from 'jquery';
import magnificPopup from 'magnific-popup';


/* Global variables
********************************************/


/* Modals
********************************************/

if ($.fn.magnificPopup) {

	$('.js-modal-video').magnificPopup({
		type: 'iframe',
		mainClass: 'c-modal-wrapper',
		removalDelay: 160,
		preloader: false,
		closeOnContentClick: false,
		closeBtnInside: false,
		closeMarkup: '<button title="%title%" type="button" class="mfp-close c-modal-close c-modal-close--outside">&#215;</button>'
	});


	$('.js-modal-image').magnificPopup({
		type: 'image',
		closeOnContentClick: false,
		closeBtnInside: false,
		image: {
			verticalFit: true
		},
		titleSrc: 'test',
		closeMarkup: '<button title="%title%" type="button" class="mfp-close c-modal-close c-modal-close--outside">&#215;</button>'
	});


	var startWindowScroll = 0;
	$('.js-modal-open').magnificPopup({
		fixedContentPos: true,
		fixedBgPos: true,
		overflowY: 'auto',
		mainClass: 'c-modal-root',
		showCloseBtn: false,
		removalDelay: 100,
		type: 'inline',
		/*callbacks: {
			beforeOpen: function() {
				startWindowScroll = $(window).scrollTop();
			},
			open: function(){
				if ( $('.mfp-content').height() < $(window).height() ){
					$('body').on('touchmove', function (e) {
						e.preventDefault();
					});
				};
				$('html').css('overflow', 'visible');
				$('body').addClass('c-body--freeze');
			},
			close: function() {
				$(window).scrollTop(startWindowScroll);
				$('body').off('touchmove');
				$('body').removeClass('c-body--freeze');
			}
		}*/
	});


	$('.c-article__image-link').not('[target="_blank"]').magnificPopup({
		type: 'image',
		closeOnContentClick: false,
		closeBtnInside: false,
		image: {
			verticalFit: true
		},
		closeMarkup: '<button title="%title%" type="button" class="mfp-close c-modal-close">&#215;</button>'
	});


	$('.js-gallery-slider').magnificPopup({
		delegate: '.gallery-item a',
		type: 'image',
		closeOnContentClick: false,
		closeBtnInside: false,
		gallery: {
			enabled: true,
			navigateByImgClick: true,
			arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow c-slider__arrow c-slider__arrow--%dir%"></button>',
			preload: [0,1] // Will preload 0 - before current, and 1 after the current image
		},
		image: {
			verticalFit: true
		},
		closeMarkup: '<button title="%title%" type="button" class="mfp-close c-modal-close c-modal-close--outside">&#215;</button>'
	});


	// close modal
	$('body').on('click', '.js-modal-close', function (e) {
		e.preventDefault();
		$.magnificPopup.close();
	});

}
